export const SET_PAYMENT_DETAILS = (state, value) => {
  state.paymentDetails = value;
};

export const SET_PAYMENT_OPTION = (state, value) => {
  state.paymentOption = value;
};

export const SET_BUYER_DATA = (state, value) => {
  if (value?.typeDocument === "foreigner") {
    value.customer_zipcode = value.zipcodenomask;
  }
  state.buyer = value;
};

export const SET_INTERESTS = (state, value) => {
  state.interests = value;
};

export const SET_FINAL_DETAILS = (state, value) => {
  state.finalDetails = value;
};

export const SET_PIX_DETAILS = (state, value) => {
  state.pixDetails = value;
};

export const SET_PARTIAL_PAYMENT = (state, value) => {
  state.partialPayment = value;
};

export const SET_CAN_PURCHASE = (state, value) => {
  state.canPurchase = value;
};

export const SET_ERROR_MESSAGE_CARD = (state, value) => {
  state.erroMessageCard = value;
};

export const SHOW_SECURITY_CHECK = (state, value) => {
  state.showSecurityCheck = value;
};

export const SET_PAYMENT_OPTIONS_DETAILS = (state, value) => {
  state.paymentOptionsDetails = value;
};

export const SET_SECURE_3DS_OPEN = (state, value) => {
  state.secure3dsOpen = value;
};
